import { render, staticRenderFns } from "./ImageGroupUploadZone.vue?vue&type=template&id=43027020&scoped=true"
import script from "./ImageGroupUploadZone.vue?vue&type=script&lang=js"
export * from "./ImageGroupUploadZone.vue?vue&type=script&lang=js"
import style0 from "./ImageGroupUploadZone.vue?vue&type=style&index=0&id=43027020&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43027020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43027020')) {
      api.createRecord('43027020', component.options)
    } else {
      api.reload('43027020', component.options)
    }
    module.hot.accept("./ImageGroupUploadZone.vue?vue&type=template&id=43027020&scoped=true", function () {
      api.rerender('43027020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/image-groups/ImageGroupUploadZone.vue"
export default component.exports